// extracted by mini-css-extract-plugin
export var section = "legalPrivacy-module--section--6M1US";
export var subtitle = "legalPrivacy-module--subtitle--ca3BK";
export var text = "legalPrivacy-module--text--pe1Tw";
export var title = "legalPrivacy-module--title--cYtQz";